import * as React from "react";
import styled from "@emotion/styled";
import breakpoint from "@/utils/breakpoint";
import Logo from "@/assets/icons/Logo";
import Row from "@/components/atoms/Row";
import Col from "@/components/atoms/Col";
// FIXME: eslint fix かけても問題なくなったら object-curly-newline を修正する
// eslint-disable-next-line object-curly-newline
import { useTheme } from "@/hooks/useTheme";
import ContractContext, { initContractStore } from "@/contexts/Contract";
import contract, { Feature } from "@/utils/contract";
import messages from "@/messages";
import MediaQueryContext, { initMediaQueryStore } from "@/contexts/MediaQuery";
import { isBlank } from "@/utils/is";

const StyledHeader = styled.div`
  background-color: white;
  padding: 24px 0 0 0;
  ${breakpoint.lessThan("sm")`
  padding-top: 15px;
  `}
`;

const StyledInfoWithIconAndText = styled.div`
  height: 57px;
  ${breakpoint.lessThan("sm")`
  text-align: center;
  padding-left: 0;
  `}
`;

const StyledIcon = styled.div`
  width: 68px;
  height: 49px;
  ${breakpoint.lessThan("sm")`
  text-align: center;
  width: 40px;
  height: 28px;
  `}
`;

const StyledInfoWithText = styled.div<{ backgroundColor?: string }>`
  max-width: 482px;
  background-color: ${({ backgroundColor = "#f7f7f7" }) => backgroundColor};
  ${breakpoint.lessThan("sm")`
  padding: 10px 20px 10px 20px;
  `}
`;

const StyledText = styled.div<{ color?: string }>`
  font-size: 14px;
  color: ${({ color = "#ffffff" }) => color};
  font-weight: 500;
`;

const StyledText2 = styled.div<{ color?: string }>`
  color: ${({ color = "#002B69" }) => color};
  font-weight: 700;
  font-size: 24px;
  ${breakpoint.lessThan("sm")`
  margin-left: 7px;
 `}
`;

const StyledText3 = styled.div<{ color?: string; backgroundColor?: string }>`
  color: ${({ color = "#333333" }) => color};
  background-color: ${({ backgroundColor = "#333333" }) => backgroundColor};
  font-size: 12px;
  font-weight: 400;
  ${breakpoint.lessThan("sm")`
  font-size: 10px;
 `}
`;

const StyledAiDiv = styled.div`
  display: flex;
  flex-direction: row;
  ${breakpoint.lessThan("sm")`
   margin-top: 7px;
   justify-content: center;
   align-items: center;
  `}
`;

const StyledDiv = styled.div`
  margin-left: 20px;
`;

const StyledLogo = styled.div`
  padding-left: 33px;
  ${breakpoint.lessThan("sm")`
   padding-left: 15px;
  `}
`;

const LogoLink = styled.a`
  text-decoration: none;
`;

const LogoImage = styled.img`
  max-width: 250px;
  max-height: 100px;
`;

const LogoText = styled.p`
  font-size: 30px;
  font-weight: 500;
  color: #666;
  text-shadow: 0 1px #ccc;

  ${breakpoint.lessThan("sm")`
    font-size: 18px;
  `}
`;

type IHeader = {
  isDescriptionEnabled?: boolean;
};

const Header = (props: IHeader) => {
  const { COLOR_THEME } = useTheme();
  const { current: range } = React.useContext(MediaQueryContext) || initMediaQueryStore("md");
  const {
    state: { logoImage, displayName, logoLink },
  } = React.useContext(ContractContext) || initContractStore(contract);
  const { state: contractInfo } = React.useContext(ContractContext) || initContractStore(contract);
  const annotations = (contractInfo.featuresObj[Feature.SERVICE_ANNOTATIONS] || {}).annotations || [
    messages.serviceAnnotation1,
    messages.serviceAnnotation2,
    messages.serviceAnnotation3,
  ];

  const renderDescText = () => (
    <StyledInfoWithText backgroundColor={range === "sm" ? 'white' : COLOR_THEME.title?.background || 'white'}>
      {annotations.map((annotation, i) => (
        <StyledText3
          key={`${i + 1}-${annotation}`}
          color={range === "sm" ? '#333333' : COLOR_THEME.title?.color || "#333333"}
          backgroundColor={range === "sm" ? 'white' : COLOR_THEME.title?.background || "white"}
        >
          {annotation}
        </StyledText3>
      ))}
    </StyledInfoWithText>
  );

  const renderMobileAiText = () => (
    <React.Fragment>
      <Row
        style={{
          paddingTop: "31px",
          paddingBottom: "30px",
          color: COLOR_THEME.title?.color,
          backgroundColor: COLOR_THEME.title?.background,
        }}
      >
        <StyledInfoWithIconAndText>
          <StyledText color={COLOR_THEME.title?.color || "#333333"}>
            あなたの自宅はいくら？かんたん無料査定！
          </StyledText>
          <StyledAiDiv>
            <StyledIcon>
              <Logo fillColor={COLOR_THEME.title?.color || COLOR_THEME.extras?.primary} height="29" width="40" />
            </StyledIcon>
            <StyledText2 color={COLOR_THEME.title?.color || COLOR_THEME.extras?.primary}>AI不動産査定</StyledText2>
          </StyledAiDiv>
        </StyledInfoWithIconAndText>
      </Row>
      <Row>{renderDescText()}</Row>
    </React.Fragment>
  );

  const renderWebAiText = () => (
    <Row
      style={{
        paddingTop: "31px",
        paddingBottom: "23px",
        color: COLOR_THEME.title?.color,
        backgroundColor: COLOR_THEME.title?.background,
      }}
    >
      <Col size={1.75}>
        <div style={{ visibility: "hidden" }}>*</div>
      </Col>
      <Col size={4.25}>
        <StyledInfoWithIconAndText>
          <StyledAiDiv>
            <Logo fillColor={COLOR_THEME.title?.color || COLOR_THEME.extras?.primary} height="49" width="68" />
            <StyledDiv>
              <StyledText color={COLOR_THEME.title?.color || "#333333"}>
                あなたの自宅はいくら？かんたん無料査定
              </StyledText>
              <StyledText2 color={COLOR_THEME.title?.color || COLOR_THEME.extras?.primary}>AI不動産査定</StyledText2>
            </StyledDiv>
          </StyledAiDiv>
        </StyledInfoWithIconAndText>
      </Col>
      <Col size={4.25}>{renderDescText()}</Col>
      <Col size={1.75}>
        <div style={{ visibility: "hidden" }}>*</div>
      </Col>
    </Row>
  );

  const renderAIDesc = () => {
    if (range === "sm") {
      return renderMobileAiText();
    } else {
      return renderWebAiText();
    }
  };

  return (
    <StyledHeader>
      <Row>
        {isBlank(logoImage) ? (
          <LogoText>{displayName}</LogoText>
        ) : (
          <StyledLogo>
            <LogoLink href={logoLink} target="_blank">
              <LogoImage src={logoImage} alt={displayName} />
            </LogoLink>
          </StyledLogo>
        )}
      </Row>
      {props.isDescriptionEnabled && renderAIDesc()}
    </StyledHeader>
  );
};

export default Header;
